import { SetStripeContact } from '@/connection/integrations/stripe';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const setStripeContactReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ email }: { email: string }, { rejectWithValue }) => {
      try {
        const updatedEmail = await SetStripeContact(email);
        return updatedEmail;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.stripe = {
          ...state.stripe,
          contact: action.payload.email,
        };
      },
    }
  );
};

export default setStripeContactReducer;
